// extracted by mini-css-extract-plugin
export var orderSummary = "_ls-0";
export var showMoreLessButton = "_ls-1";